import { html } from '@shared/utils/rendering/html';
import { createContext } from 'preact';
import { useContext, useState } from 'preact/hooks';

const CacheManagementContext = createContext();

export function CacheManagementProvider({ children }) {
    const [cacheKeys, setCacheKeys] = useState({});

    const setKey = (name, value) => {
        if (name && value) {
            setCacheKeys({
                ...cacheKeys,
                [name]: value,
            });
        }
    };

    const getKey = (name) => {
        if (name) {
            return cacheKeys[name];
        }
        return '';
    };

    return html`
        <${CacheManagementContext.Provider}
            value=${{
                setKey,
                getKey,
            }}
        >
            ${children}
        </${CacheManagementContext.Provider}>
    `;
}

export function useCacheManagement() {
    return useContext(CacheManagementContext);
}
